import { useAnalyticSession } from "@octopusdeploy/portal-analytics";
import type { ArgoCDInstallHelmCommandGeneratedFields } from "~/analytics/AnalyticSession";
import type { ArgoCDHelmCommandGeneratedDispatcher, ArgoCDHelmCommandGeneratedEvent } from "~/analytics/Analytics";
export function useArgoCDInstanceHelmCommandGeneratedDispatcher(): ArgoCDHelmCommandGeneratedDispatcher {
    const session = useAnalyticSession();
    return (name: string, event: ArgoCDHelmCommandGeneratedEvent) => {
        const fields: ArgoCDInstallHelmCommandGeneratedFields = {
            "Gateway Name": session.anonymize(`${event.gatewayName}`),
            "Space Id": session.anonymize(`${event.spaceId}`),
            "Unique Identifier": session.anonymize(`${event.spaceId}-${event.gatewayName}`),
        };
        session.track(name, fields);
    };
}
